export const useHelpers = () => {
    
    const extractPermissionsSelected = (items, selected = []) => {
        items.forEach((item) => {
            if (item.is_assigned) {
                selected.push(item);
            }
            if (item.hijos && item.hijos.length > 0) {
                extractPermissionsSelected(item.hijos, selected);
            }
        });
        return selected;
    };
    
    return Object.freeze({
        extractPermissionsSelected,
    })
}